import { Component, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';

import { LicenseService } from '../../core/services/http-services/license.service';
import { RequestLicenseModel } from '../../core/models/view-models/license-models/request-license.model';
import { AppConstants } from '../../app.constants';
import { LicenseDialogMessagesEnum } from '../../core/enums/toastr-messages/license-dialog-messages.enum';

@Component({
  selector: 'app-modal-request-license',
  templateUrl: './modal-request-license.component.html',
  styleUrls: ['./modal-request-license.component.scss']
})
export class ModalRequestLicenseComponent implements OnDestroy {

  public requestLicense: RequestLicenseModel = new RequestLicenseModel();

  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly dialogRef: MatDialogRef<ModalRequestLicenseComponent>,
    private readonly licenseService: LicenseService,
    private readonly toastrService: ToastrService) { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.subscriptions.add(
      this.licenseService.generateLicenseRequest(this.requestLicense).subscribe((data: Blob) => {
        this.toastrService.success(LicenseDialogMessagesEnum.FileGeneratedSuccess, LicenseDialogMessagesEnum.LicenseRequestTitle);
        this.close();
        const blob: Blob = new Blob([data], { type: data.type });
        saveAs(blob, AppConstants.LICENSE_REQUEST_FILE_NAME);
      }));
  }
}
